import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { Skeleton } from "@/components/ui/skeleton";

type Bucket = { month: string; invoiced: number; paid: number };

type Props = {
  data: Bucket[] | undefined;
  isLoading: boolean;
};

function shortMonth(m: string): string {
  const [year, mo] = m.split('-');
  const d = new Date(Number(year), Number(mo) - 1, 1);
  return d.toLocaleString('en-US', { month: 'short', year: '2-digit' });
}

const fmt = (v: number) =>
  `$${v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v.toFixed(0)}`;

export default function InvoiceMonthlyChart({ data, isLoading }: Props) {
  const chartData = (data || []).map(b => ({
    name: shortMonth(b.month),
    Invoiced: Number(b.invoiced.toFixed(2)),
    Collected: Number(b.paid.toFixed(2)),
  }));

  return (
    <Card className="flex-1">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">Invoiced vs Collected</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-40 w-full" />
        ) : chartData.length === 0 ? (
          <div className="h-40 flex items-center justify-center text-muted-foreground text-sm">No data</div>
        ) : (
          <ResponsiveContainer width="100%" height={160}>
            <BarChart data={chartData} barGap={2}>
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tickFormatter={fmt} tick={{ fontSize: 11 }} width={48} />
              <Tooltip formatter={(v: number) => `$${v.toFixed(2)}`} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar dataKey="Invoiced" fill="#3b82f6" radius={[3, 3, 0, 0]} />
              <Bar dataKey="Collected" fill="#22c55e" radius={[3, 3, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
